// styles
import './Companies.css'

// store
import { dbDataStore, triggersStore } from '../../store/Store'
import DisplayList from '../../components/DisplayList';
import useGetFetch from '../../hooks/useGetFetch';
import Loading from '../../components/Loading';
import ErrorDisplay from '../../components/ErrorDisplay';

export default function Companies() {
    // global state
    const companyTrigger = triggersStore(triggers => triggers.companyTrigger)
    const setCompanyTrigger = triggersStore(triggers => triggers.setCompanyTrigger)
    const setCompanyData = dbDataStore(dbData => dbData.setCompanyData)
    const companyData = dbDataStore(dbData => dbData.companyData)
    const setGlobalCompanies = dbDataStore(dbData => dbData.setGlobalCompanies)
    
    
    const {isPending, error, statusCode} = useGetFetch(`${process.env.REACT_APP_BACKEND}/pc/tenant-account-companies`, setGlobalCompanies)
    
    if (isPending) {
        return <Loading />
    } else if (error) {
        return <ErrorDisplay message={error} code={statusCode} />
    }
    
    return (
        <div className='container-fluid'>
            <DisplayList 
                coll={'Companies'}
                docs={companyData}
                trigger={companyTrigger}
                setTrigger={setCompanyTrigger}
                url={`${process.env.REACT_APP_BACKEND}/pc/account-companies`}
                setState={setCompanyData}
                updateRequiredField={"company_id"}
                updateRequiredValue={0}
                statusToggle={true}
                setDeleteState={setCompanyData}
            />
        </div>
    )
}